export default [
  "SystemTypeChilledWaterSystem",
  "SystemTypeCondensedWaterSystem",
  "SystemTypeAirsideSystem",
  "SystemTypeHotWaterSystem",
  "SystemTypeAirside"
];
